<app-navbar></app-navbar>
<div class="container-fluid">
  <div class="panel modern-card">
    <div class="panel-header modern-header">
      <h2 class="text-white">
        <i class="fas fa-search me-2 text-white"></i>
        Consulta de Auditoria
      </h2>
    </div>
    <div class="panel-body">
      <!-- Formulário de Filtros -->
      <form [formGroup]="filtroForm" (ngSubmit)="carregarDados()" class="filtro-form modern-form">
        <div class="filtros-grid modern-grid">
          <div class="form-group">
            <label for="acao">
              <i class="fas fa-tasks me-1"></i> Ação
            </label>
            <select id="acao" formControlName="acao" class="form-control">
              <option value="">Todas as ações</option>
              <option *ngFor="let acao of tiposAcao" [value]="acao">{{acao}}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="dataInicio">
              <i class="far fa-calendar-alt me-1"></i> Data Início
            </label>
            <input 
              type="date" 
              id="dataInicio" 
              formControlName="dataInicio" 
              class="form-control">
          </div>
          <div class="form-group">
            <label for="dataFim">
              <i class="far fa-calendar-alt me-1"></i> Data Fim
            </label>
            <input 
              type="date" 
              id="dataFim" 
              formControlName="dataFim" 
              class="form-control">
          </div>
          <div class="form-group">
            <label for="nomeUsuario">
              <i class="fas fa-user me-1"></i> Nome do Usuário
            </label>
            <select
              id="nomeUsuario"
              formControlName="nomeUsuario"
              class="form-control">
              <option value="">Todos</option>
              <option *ngFor="let nome of nomesUsuarios" [value]="nome">{{ nome }}</option>
            </select>
          </div>
          <div class="form-buttons modern-buttons">
            <button type="submit" class="btn btn-primary">
              <i class="fas fa-search me-1"></i> Consultar
            </button>
            <button type="button" class="btn btn-secondary" (click)="limparFiltros()">
              <i class="fas fa-eraser me-1"></i> Limpar
            </button>
          </div>
        </div>
      </form>

      <!-- Área de carregamento -->
      <div *ngIf="carregando" class="carregando-container modern-loader">
        <div class="spinner modern-spinner"></div>
        <p>Carregando dados, aguarde...</p>
      </div>

      <!-- Área de erro -->
      <div *ngIf="erroCarregamento" class="erro-container modern-error">
        <i class="fas fa-exclamation-triangle text-danger"></i>
        <p>{{mensagemErro}}</p>
        <button class="btn btn-outline-primary" (click)="carregarDados()">
          <i class="fas fa-sync-alt"></i> Tentar novamente
        </button>
      </div>

      <!-- Sem resultados -->
      <div *ngIf="!carregando && !erroCarregamento && resultados.length === 0" class="sem-resultados modern-empty">
        <i class="fas fa-info-circle text-info"></i>
        <p>Nenhum registro encontrado com os filtros selecionados.</p>
      </div>

      <!-- Tabela de resultados -->
      <div *ngIf="!carregando && !erroCarregamento && resultados.length > 0" class="table-container modern-table-container">
        <table class="table table-striped modern-table">
          <thead>
            <tr>
              <th>
                <span class="th-icon-label">
                  <i class="fas fa-user"></i>
                  <span>Usuário</span>
                </span>
              </th>
              <th>
                <span class="th-icon-label">
                  <i class="fas fa-user-tag"></i>
                  <span>Perfil</span>
                </span>
              </th>
              <th>
                <span class="th-icon-label">
                  <i class="fas fa-bolt"></i>
                  <span>Ação</span>
                </span>
              </th>
              <th>
                <span class="th-icon-label">
                  <i class="fas fa-clock"></i>
                  <span>Data/Hora</span>
                </span>
              </th>
              <th>
                <span class="th-icon-label">
                  <i class="fas fa-align-left"></i>
                  <span>Resumo</span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of resultados; let i = index">
              <tr [class.resumo-row]="resumoVisivel === i">
                <td><strong>{{item.nomeUsuario || '-'}}</strong></td>
                <td><span class="badge badge-light">{{item.papel || '-'}}</span></td>
                <td>
                  <span class="badge" [ngClass]="getCorBadge(item.acao)">
                    <i class="fas fa-circle me-1" [ngClass]="getCorBadge(item.acao)"></i>
                    <span [innerHTML]="acaoQuebrada(item.acao)"></span>
                  </span>
                </td>
                <td>{{formatarData(item.dataHora)}}</td>
                <td>
                  <button 
                    class="btn ver-detalhes-btn" 
                    (click)="toggleResumo(i)">
                    <i class="fas" [ngClass]="resumoVisivel === i ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    {{resumoVisivel === i ? 'Ocultar' : 'Ver Detalhes'}}
                  </button>
                </td>
              </tr>
              <tr *ngIf="resumoVisivel === i">
                <td colspan="5" class="resumo-detalhes">
                  <pre>{{formatarResumo(item.resumo)}}</pre>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        
        <!-- Paginação -->
        <div class="paginacao modern-pagination">
          <div class="paginacao-info">
            <i class="fas fa-database me-1"></i>
            Exibindo <b>{{resultados.length}}</b> de <b>{{totalItens}}</b> registros | Página <b>{{paginaAtual}}</b> de <b>{{totalPaginas}}</b>
          </div>
          <div class="paginacao-controles">
            <button 
              [disabled]="paginaAtual === 1" 
              (click)="trocarPagina(1)" 
              class="btn btn-sm btn-outline-secondary"
              title="Primeira página">
              <i class="fas fa-angle-double-left"></i>
            </button>
            <button 
              [disabled]="paginaAtual === 1" 
              (click)="trocarPagina(paginaAtual - 1)" 
              class="btn btn-sm btn-outline-secondary"
              title="Página anterior">
              <i class="fas fa-angle-left"></i>
            </button>
            
            <button 
              *ngFor="let pagina of paginas" 
              [class.active]="pagina === paginaAtual"
              (click)="trocarPagina(pagina)" 
              class="btn btn-sm btn-outline-secondary pagina-numero modern-page-btn">
              {{pagina}}
            </button>
            
            <button 
              [disabled]="paginaAtual === totalPaginas" 
              (click)="trocarPagina(paginaAtual + 1)" 
              class="btn btn-sm btn-outline-secondary"
              title="Próxima página">
              <i class="fas fa-angle-right"></i>
            </button>
            <button 
              [disabled]="paginaAtual === totalPaginas" 
              (click)="trocarPagina(totalPaginas)" 
              class="btn btn-sm btn-outline-secondary"
              title="Última página">
              <i class="fas fa-angle-double-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
